export const stopEvents = (e: React.MouseEvent | React.PointerEvent) => {
  e.stopPropagation();
  (e as React.MouseEvent).nativeEvent?.stopPropagation();
};
